import React, { memo } from "react";
import SkeletonLoader from "./SkeletonLoader";

const Preloader = () => {
  return (
    <div
      className="uk-preloader"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#fff",
        zIndex: 9999,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>

      {/* Loading skeleton for better perceived performance */}
      <div style={{ marginTop: "2rem", width: "300px" }}>
        <SkeletonLoader
          height="20px"
          width="80%"
          style={{ marginBottom: "1rem" }}
        />
        <SkeletonLoader
          height="20px"
          width="60%"
          style={{ marginBottom: "1rem" }}
        />
        <SkeletonLoader height="20px" width="70%" />
      </div>

      <div
        style={{
          marginTop: "2rem",
          fontSize: "14px",
          color: "#666",
          textAlign: "center",
        }}
      >
        Loading your experience...
      </div>
    </div>
  );
};

export default memo(Preloader);
